import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type GeneralPageSectionProps = {
  children: ReactNode;
  spacing?: 'intro' | 'default';
  className?: string;
};

export default function GeneralPageSection({
  children,
  spacing = 'default',
  className,
}: GeneralPageSectionProps) {
  return (
    <div
      className={cn(
        'px-4 pt-16 font-inter_font text-heading-black md:px-6 md:pt-24',
        spacing === 'intro' ? 'xl:pt-[120px]' : 'xl:pt-[140px]',
        className
      )}
    >
      <div className="mx-auto w-full max-w-[1340px]">{children}</div>
    </div>
  );
}
